export default "__VITE_ASSET__yYyTtwi$__"